<template>
  <div class="button-menu">
    <!-- Share -->
    <button class="mute-button" @click="shareScreen(!isShare)" v-if="isWidthWide()">
      <span class="mdi mdi-cast-off mdi-24px" v-if="isShare"></span>
      <span class="mdi mdi-cast-connected mdi-24px" v-else></span>
    </button>
    <!-- 切断ボタン -->
    <button class="hangup-button"
      id="btn_disconnect"
      type="button"
      @click="endConnect()">
      <span class="mdi mdi-phone-hangup mdi-24px"></span>
    </button>
    <button class="mute-button"
      id="btn_mute"
      type="button"
      @click="setAudioSwitch(isMute)">
      <span class="mdi mdi-microphone mdi-24px" v-if="!isMute"></span>
      <span class="mdi mdi-microphone-off mdi-24px" v-else></span>
    </button>
    <button class="blind-button"
      id="btn_blind"
      type="button"
      @click="setVideoSwitch(isBlind)">
      <span class="mdi mdi-camcorder mdi-24px" v-if="!isBlind"></span>
      <span class="mdi mdi-camcorder-off mdi-24px" v-else></span>
    </button>
    <button class="chat-button"
      id="btn_chat"
      type="button"
      @click="changeChatModal(true)"
      v-if="!isShowChat">
      <div class="unread" v-if="unRead.count > 0">
        <p>{{unRead.count < 10 ? unRead.count : '9+'}}</p>
      </div>
      <span class="mdi mdi-comment-processing-outline mdi-24px"></span>
    </button>
  </div>
</template>
<script>
export default {
  props: {
    isBlind: {
      type: Boolean,
      required: true
    },
    isMute: {
      type: Boolean,
      required: true
    },
    isShare: {
      type: Boolean,
      required: true
    },
    isShowChat: {
      type: Boolean,
      required: true
    },
    unRead: {
      type: Object,
      required: true
    }
  },
  methods: {
    isWidthWide () {
      return window.outerWidth > 500
    },
    shareScreen (flg) {
      this.$emit('shareScreen', flg)
    },
    setAudioSwitch (flg) {
      this.$emit('setAudioSwitch', flg)
    },
    setVideoSwitch (flg) {
      this.$emit('setVideoSwitch', flg)
    },
    endConnect () {
      this.$emit('endConnect')
    },
    changeChatModal (flg) {
      this.$emit('changeChatModal', flg)
    },
  }
}
</script>
<style lang="scss" scoped>
.button-menu {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100px;
  z-index: 301;
}
.hangup-button {
  height: 64px;
  width: 64px;
  border-radius: 50%;
  background: red;
  color: white;
  border: none;
  margin: 15px;
}
.mute-button {
  height: 64px;
  width: 64px;
  border-radius: 50%;
  background: rgba(55, 55, 55, 0.3);
  color: white;
  border: none;
  margin: 15px;
}
.blind-button {
  height: 64px;
  width: 64px;
  border-radius: 50%;
  background: rgba(55, 55, 55, 0.3);
  color: white;
  border: none;
  margin: 15px;
}
.chat-button {
  position: relative;
  height: 64px;
  width: 64px;
  border-radius: 50%;
  background: rgba(85, 195, 85, 0.8);
  color: white;
  border: none;
  margin: 15px;
}
.unread {
  position: absolute;
  top: -8px;
  right: -8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 12.5px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: white;
  background: #EE2C98;
}
@media screen and (max-width: 500px) {
  .video-size-remote {
    width: 100% !important;
    height: 100% !important;
  }
  .button-menu {
    position: fixed;
    overflow-x: scroll;
  }
  .hangup-button, .mute-button, .blind-button, .chat-button {
    height: 48px;
    width:  48px;
    margin: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/VideoInterview/organisms/MenuBar.vue